import axios from 'axios';
import React, { ReactNode } from 'react';
import {
  filter,
  first,
  from,
  map,
  Observable,
  publishReplay,
  refCount,
  switchMap,
} from 'rxjs';

import { addresses$ } from '../../../../../../api/addresses/addresses';
import { applicationConfig } from '../../../../../../applicationConfig';
import { ErgopadWhitelistForm } from './ErgopadWhitelistForm';

export const getErgopadWhitelistForm = (): Observable<
  ReactNode | ReactNode[] | string
> =>
  addresses$.pipe(
    filter((addresses) => addresses.length > 0),
    first(),
    switchMap((addresses) =>
      from(
        axios.post(`${applicationConfig.ergopadUrl}/staking/staked/`, {
          addresses,
        }),
      ).pipe(
        map((res) => (
          <ErgopadWhitelistForm
            address={addresses[0]}
            totalErgopadStaked={res.data.totalStaked || 0}
          />
        )),
      ),
    ),
    publishReplay(1),
    refCount(),
  );
